/**
 * Dynamic load more.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class LoadMore
 */
class LoadMore {

    cache() {

        this.postsPerPage    = 8;
        this.loadMoreText    = $( '#js-load-more-text' );
        this.loadMoreSpinner = $( '#js-load-more-spinner' );
        this.postsWrapper    = $( '#js-article-list' );
        this.postsUl         = $( '#archive-articles' );
        this.loadMoreButton  = $( '#js-load-more' );
        this.loadMoreLoaded  = themeData.themeStrings.load_more_loaded;
        this.foundPosts      = this.postsWrapper.attr( 'data-found-posts' );
    }

    events() {
        this.loadMoreButton.on( 'click', e => this.loadMore( e ) );
    }

    loadMore( e ) {

        e.preventDefault();

        // Show spinner and hide load more text.
        this.loadMoreText.addClass( 'hidden' );
        this.loadMoreSpinner.removeClass( 'hidden' );

        const currentSet         = this.postsWrapper.attr( 'data-current-set' );
        const selectArticleCat   = this.postsWrapper.attr( 'data-select-article-cat' );
        const selectPostTag      = this.postsWrapper.attr( 'data-select-post-tag' );
        const relationArticleCat = this.postsWrapper.attr( 'data-relation-article-cat' );
        const relationPostTag    = this.postsWrapper.attr( 'data-relation-post-tag' );
        const added              = +currentSet + 1;
        const totalNumOfPosts    = ( +added * +this.postsPerPage );

        // Load more with DustPress.js
        dp( 'PageFlexible/Articles', {
            partial: 'article-load-more',
            tidy: true,
            data: true,
            args: {
                /*eslint-disable */
                ajax_params: {
                    currentSet: added,
                    selectArticleCat: selectArticleCat.split( ',' ),
                    selectPostTag: selectPostTag.split( ',' ),
                    relationArticleCat: relationArticleCat,
                    relationPostTag: relationPostTag,
                }
                /*eslint-enable */
            }
        }).then( ( response ) => {

            // Hide spinner and show load more text.
            this.loadMoreText.removeClass( 'hidden' );
            this.loadMoreSpinner.addClass( 'hidden' );

            // Inform screen readers that there's more articles loaded.
            wp.a11y.speak( this.loadMoreLoaded, 'polite' );

            // Append posts to the wrapping element.
            this.postsUl.append( response.success );

            // Set new value to data-attribute data-current.
            this.postsWrapper.attr( 'data-current-set', added );

            // If found posts is less than total number of posts hide the load more button.
            if ( this.foundPosts <= totalNumOfPosts ) {
                this.loadMoreButton.hide();
            }
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = LoadMore;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/load-more.js